// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"20f8483d","325":"74844d4d","417":"7aed4d76","488":"a9832f70"}[chunkId] + ".chunk.js";
};